import useMedia from '@charlietango/use-media'
import React, { useRef } from 'react'
import { createPortal } from 'react-dom'
import useOnClickOutside from '../../hooks/useOnClickOutside'
import usePrevious from '../../hooks/usePrevious'
import useReadAloudStatus from '../../hooks/useReadAloudStatus'
import { useTextSelection } from '../../hooks/useTextSelection'
import styles from './readAloudPopover-style.css'

const Portal = ({ children }) => {
  return createPortal(children, document.body)
}

const ReadAloudPopover = () => {
  const { isReadingAloud } = useReadAloudStatus()
  const { isCollapsed, clientRect } = useTextSelection()
  const sizeMobile = useMedia({ maxWidth: 767 })
  const ref = useRef(null)
  const wasCollapsed = usePrevious(isCollapsed)
  const position = useRef(null)

  // stop read aloud if user clicks somewhere else
  const handleClickOutside = () => {
    window.vFact_dostop()
  }
  useOnClickOutside(ref, handleClickOutside)

  // stop/start read aloud
  const handleReadAloud = () => {
    if (isReadingAloud) {
      window.vFact_dostop()
    } else {
      window.vFact_doplay()
    }
  }

  if (
    (isReadingAloud && clientRect && !wasCollapsed) ||
    (isCollapsed === false && clientRect)
  ) {
    position.current = clientRect
  } else if (!isReadingAloud) {
    position.current = null
  }

  const rect = position.current
  if (!rect) return null

  return (
    <Portal>
      {/* styling:
       * - center popover over text selection, based on where selection starts + half of width of button (85) + half of selection width
       * - set popover to clienRect top + how long the user has scrolled */}
      <div>
        <button
          className={styles.popover}
          onClick={handleReadAloud}
          onTouchEnd={event => {
            event.preventDefault() // prevent text deselection when clicking button on touch devices (touch removes text selection when something else is clicked)
            handleReadAloud()
          }}
          ref={ref}
          style={{
            left: `${
              sizeMobile
                ? window.innerWidth / 2 - 85
                : rect.left - 85 + rect.width / 2 > 5
                ? rect.left - 85 + rect.width / 2
                : 5
            }px`,
            top: `${sizeMobile ? '' : rect.top - 60 + window.scrollY}px`,
            bottom: `${sizeMobile ? '15%' : ''}`,
            position: `${sizeMobile ? 'fixed' : 'absolute'}`,
          }}
        >
          {isReadingAloud ? 'Stop oplæsning' : 'Læs op'}
        </button>
      </div>
    </Portal>
  )
}

export default ReadAloudPopover



// WEBPACK FOOTER //
// ./src/components/ReadAloudPopover/ReadAloudPopover.js